import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import appConfig from '../../appConfig';
import UMOGalleryHeader from './UMOGalleryHeader';
import UMOGalleryHeaderInfo from './UMOGalleryHeaderInfo';
import UMOGridLayout from './UMOGridLayout';
import UMOMetadataPanel from '../UMOMetadataPanel';
import {
  toggleUMODetailView,
  toggleCompareView,
  toggleFullImageView,
  toggleNavPanel,
  triggerNavPanelComponent,
} from '../../actions/mainUI';
import { retrieveUMOs, setLastSelectedUMOID, updatePageNumber } from '../../actions/umoGallery';
import { moveBetweenWorkspaces, moveUMO, addToWorkspace } from '../../actions/umo';
import { viewTypes } from '../../constants/umoGallery';
import { WorkspaceTag, SearchParams } from '../../utils/searchUtils';
import { addError } from '../../actions/messageDialog';
import { moveUmoHandler } from '../../utils/umoUtils';
import { CARD_VIEW_URL } from '../../constants/workspaceCards';
import HighlightsView from '../HighlightsView';
import MetaAttach from '../MetaAttach';
import { META_ATTACH_VIEW_NONE } from '../../constants/metaAttachStates';
import { DEFAULT_COLLECTION_ID } from '../../constants/session';
import piction from '../../utils/piction';
import { SESSION_EXPIRED_MESSAGE } from '../../constants/sessionStateTypes';
import UMONoItemFound from '../UMONoItemFound';
import { changeDataLanguage } from '../../actions/session';
import { NAV_CATEGORIES, NAV_WORKSPACES } from '../../constants/nav';

const mapStateToProps = (state) => ({
  umoGallery: state.umoGallery,
  session: state.session,
  mainUI: state.mainUI,
  workspacePreview: state.workspacePreview,
  metaAttach: state.metaAttach,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchSetLastSelectedUMOID: (umoId) =>
    dispatch(setLastSelectedUMOID(umoId)),
  onPageChange: (pageNumber) => dispatch(updatePageNumber(pageNumber)),
  toggleUMODetailViewDispatch: (umoID) => dispatch(toggleUMODetailView(umoID)),
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
  retrieveUMOs: (searchParams) => dispatch(retrieveUMOs(searchParams)),
  moveUMO: (umoList, categoryID, searchParams, isCopy) =>
    dispatch(moveUMO(umoList, categoryID, searchParams, isCopy)),
  addToWorkspace: (workspaceID, umoList, searchParams, isCopy) =>
    dispatch(addToWorkspace(workspaceID, umoList, searchParams, { isCopy })),
  showErrorMessage: (message) => dispatch(addError(message)),
  moveBetweenWorkspaces: (fromWorkspaceID,toWorkspaceID,umoList,searchParams,isCopy) =>
    dispatch(
      moveBetweenWorkspaces(fromWorkspaceID,toWorkspaceID,umoList,searchParams,isCopy)
    ),
  toggleCompareViewDispatch: (selectedUMOIDs) =>
    dispatch(toggleCompareView(selectedUMOIDs)),
  toggleFullImageViewDispatch: (isShown, umoData) =>
    dispatch(toggleFullImageView(isShown, umoData)),
  changeDataLanguageDispatch: (lang) => {
    dispatch(changeDataLanguage(lang));
    dispatch(retrieveUMOs());
  },
});

class UMOGallery extends Component {
  constructor(props) {
    super(props);

    // is result set a workspace
    const isWorkspace = props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE;
    const tagList = props.umoGallery.getIn(['searchParams', 'tagList']);
    const tag = tagList && tagList.length === 1 && isWorkspace &&
      tagList[0] instanceof WorkspaceTag ? tagList[0] : null;
    const title =
      (props.umoGallery.get('galleryType') === SearchParams.searchTypes.WORKSPACE ||
        props.umoGallery.get('galleryType') === SearchParams.searchTypes.CATEGORY) &&
      tagList.length === 1 ? tagList[0].label : null;
    this.state = {
      mainTitle: title,
      mainDescription: tag ? tag.description : null,
      isWorkspace,
      workspaceID: tag ? tag.value : null,
      isMoving: false,
      cardViewTimes: null,
      selectedUmoData: null,
      isSideMetaLoading: false,
    };
    this.copyUMOs = this.copyUMOs.bind(this);
    this.categorySelectClick = this.categorySelectClick.bind(this);
    this.stopUmoCopy = this.stopUmoCopy.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.getCardViewTimes = this.getCardViewTimes.bind(this);
  }

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      const isWorkspace =
        this.props.umoGallery.get('galleryType') ===
        SearchParams.searchTypes.WORKSPACE;
      const tagList = this.props.umoGallery.getIn(['searchParams', 'tagList']);
      const oldTagList = prevProps.umoGallery.getIn([
        'searchParams',
        'tagList',
      ]);
      if (tagList !== oldTagList) {
        const tag =
          tagList &&
          tagList.length === 1 &&
          isWorkspace &&
          tagList[0] instanceof WorkspaceTag
            ? tagList[0]
            : null;
        const title =
          (this.props.umoGallery.get('galleryType') ===
            SearchParams.searchTypes.WORKSPACE ||
            this.props.umoGallery.get('galleryType') ===
              SearchParams.searchTypes.CATEGORY) &&
          tagList.length === 1
            ? tagList[0].label
            : null;
        this.setState({
          mainTitle: title,
          mainDescription: tag ? tag.description : null,
          isWorkspace,
          workspaceID: tag ? tag.value : null,
        });
        // checking if workspace data changed, to get card data updates
        const oldTag =
          oldTagList &&
          oldTagList.length === 1 &&
          isWorkspace &&
          oldTagList[0] instanceof WorkspaceTag
            ? oldTagList[0]
            : null;
        if (isWorkspace && tag && tag !== oldTag) {
          this.getCardViewTimes(tag.value);
        }
      }
    }
    if (
      this.props.umoGallery.get('lastSelectedUMOID') !== null &&
      this.props.umoGallery.get('selectedUMOIDs').toJS().length === 0
    ) {
      this.props.dispatchSetLastSelectedUMOID(null);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      this.stopUmoCopy();
    }
  }

  getUMOData() {
    const { mainUI } = this.props;
    const sideMetaUmoId = mainUI.get('metaPanelUmoId');
    if (
      !sideMetaUmoId ||
      this.state.isSideMetaLoading ||
      (this.state.selectedUmoData &&
        this.state.selectedUmoData.id == sideMetaUmoId)
    ) {
      return;
    }
    this.setState({ isSideMetaLoading: true });
    const callData = appConfig.alternateReps
      ? {
          zoomify: 'true',
          CHECK_ALTERNATE_REPS: 'TRUE',
          ALTERNATE_COLLECTION: appConfig.alternateReps[1],
          ALTERNATE_METATAG: appConfig.alternateReps[0],
          ALTERNATE_EXCLUDE_RELATIONAL: appConfig.alternateExcRelational,
        }
      : {
          zoomify: 'true',
          ENABLE_ALTERNATE: 'true',
        };
    if (mainUI.get('metaPanelUmoId')) {
      piction
        .getUMOs(`UMO_ID:"${mainUI.get('metaPanelUmoId')}"`, callData)
        .then((res) => {
          this.setState({
            selectedUmoData: res.umoList.all[0],
            isSideMetaLoading: false,
          });
        });
    }
    // .then((res) => {
    // if (res.umoList.all[0]) {
    // umo = res.umoList.all[0];
    // return <UMOMetadataPanel umo={umo} />;
    // }
    // return null;
    // this.handleError(this.props.intl.formatMessage({ id: 'umoDetailView.requestUMOError' }));
    // })
    // .catch((err) => {
    // return null;
    // if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
    // this.props.sessionExpired(err);
    // this.closeModal();
    // } else {
    // this.handleError(err);
    // }
    // });
  }

  /*
   * Returns A JSON Object/Array of umo_ids
   * that have cards and view times when
   * this usernm last view the card (may be null)
   * params catid, usernm
   * */
  getCardViewTimes(workspaceID) {
    const username = this.props.session.get('username').toUpperCase();
    $.get(CARD_VIEW_URL, {
      catid: workspaceID,
      usernm: username,
      SURL: this.props.session.get('surlCookie')
        ? null
        : this.props.session.get('surl'),
    }).done((data) => {
      this.setState({ cardViewTimes: data });
    });
  }

  stopUmoCopy() {
    this.setState({ isMoving: false });
    $('.umo-gallery__copy-screen_overlay').css('visibility', 'hidden');
    $('.nav-options').removeAttr('style');
    $('.nav-options').removeClass('nav-options-disabled');
    $('.umo-gallery-header').removeAttr('style');
    $('.header__advSearch-button').prop('disabled', false);
    $('.search-simple').removeAttr('style');
    this.props.dispatch(triggerNavPanelComponent(null));
    const catList = $('.panel-list');
    for (let i = 0; i < catList.length; i += 1) {
      catList[i].removeEventListener('click', this.categorySelectClick, false);
    }
    if (this.props.workspacePreview.get('selectedID')) {
      $('.workspace-preview')[0].removeEventListener(
        'click',
        this.categorySelectClick,
        false
      );
    }
  }

  categorySelectClick(e) {
    if (e.target.id) {
      e.stopPropagation();
      this.stopUmoCopy();
      const selectedUMOIDs = this.props.umoGallery.get('selectedUMOIDs');
      const isSelectAll = this.props.umoGallery.get('isSelectAll');
      const isTargetWorkspace =
        e.target.id &&
        ($('.nav-workspace').children($(e.target)).length > 0 ||
          e.target.classList.contains('workspace-preview') ||
          $(`#${e.target.id}.workspace-preview`)[0]);
      const origin = {
        id: this.state.workspaceID,
        isWorkspace: this.state.isWorkspace,
      };
      const target = {
        id: e.target.id || this.props.workspacePreview.get('selectedID'),
        isWorkspace: isTargetWorkspace,
        editable: e.target.dataset.editable !== 'false',
      };
      moveUmoHandler(
        origin,
        target,
        selectedUMOIDs,
        this.props.dispatch,
        isSelectAll ? this.props.umoGallery.get('searchParams') : null,
        true
      );
    }
  }

  copyUMOs(isUMOGalleryWorkspace) {
    if (this.state.isMoving) {
      this.stopUmoCopy();
    } else {
      this.props.dispatch(toggleNavPanel(true));
      this.props.dispatch(triggerNavPanelComponent(isUMOGalleryWorkspace ? NAV_WORKSPACES : NAV_CATEGORIES));
      $('.search-simple').css('pointer-events', 'none');
      $('.header__advSearch-button').prop('disabled', true);
      $('.umo-gallery-header').css('pointer-events', 'none');
      $('.nav-options').addClass('nav-options-disabled');
      $('.umo-gallery__copy-screen_overlay').css('visibility', 'visible');

      // set listeners for click on category list and pinned workspace elements

      const catList = $('.panel-list');
      if (catList.length > 0) {
        for (let i = 0; i < catList.length; i += 1) {
          catList[i].addEventListener('click', this.categorySelectClick, false);
        }
      } else {
        const observer = new MutationObserver((mutationsList, observer) => {
          const catList = $('.panel-list');
          if (catList.length > 0) {
            for (let i = 0; i < catList.length; i += 1) {
              catList[i].addEventListener(
                'click',
                this.categorySelectClick,
                false
              );
            }
            // Once the panel list is found and event listeners are added, disconnect the observer
            observer.disconnect();
          }
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      if (this.props.workspacePreview.get('selectedID')) {
        $('.workspace-preview')[0].addEventListener(
          'click',
          this.categorySelectClick,
          false
        );
      }
      this.setState({ isMoving: true });
    }
  }

  centerMetaRelatedUmo() {
    const element = document.getElementById(
      `scrollid-${this.props.mainUI.get('metaPanelUmoId')}`
    );
    if (!element) return null;
    element.scrollIntoView({ block: 'center' });
    return null;
  }

  renderMetaPanel() {
    const { umoGallery, mainUI } = this.props;
    const sideMetaUmoId = mainUI.get('metaPanelUmoId');
    if (!sideMetaUmoId) return null;
    if (!this.state.selectedUmoData) return null;
    if (umoGallery.get('isRequesting')) return null;
    return (
      <UMOMetadataPanel
        className="meta-panel"
        isDataLoading={this.state.isSideMetaLoading}
        umo={this.state.selectedUmoData}
        dispatch={this.props.dispatch}
      />
    );
  }

  render() {
    const {
      dispatch,
      umoGallery,
      session,
      metaAttach,
      onPageChange,
      toggleUMODetailViewDispatch,
      mainUI,
      workspacePreview,
      toggleCompareViewDispatch,
      changeDataLanguageDispatch,
      intl,
    } = this.props;
    this.getUMOData();
    const searchParams = umoGallery.get('searchParams');
    const isOptionalIconsOverflow = !!appConfig.reportImage && !!appConfig.enableLinkShare &&
     !!appConfig.enableMetaEdit && !appConfig.disableZoomifyIcon;
    return (
      <div className="main__umo-gallery">
        <UMOGalleryHeader
          mainTitle={this.state.mainTitle}
          isUMOGalleryWorkspace={this.state.isWorkspace}
          sortBy={umoGallery.get('sortBy')}
          sortByIsDescending={umoGallery.get('sortByIsDescending')}
          dispatch={dispatch}
          umoGalleryViewType={mainUI.get('umoGalleryViewType')}
          searchParams={searchParams}
          selectedWorkspaceData={
            this.state.isWorkspace
              ? { id: this.state.workspaceID }
              : {
                  id: workspacePreview.get('selectedID'),
                  ...workspacePreview.get('selectedData').toJS(),
                }
          }
          selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
          isSelectAll={umoGallery.get('isSelectAll')}
          copyUMOs={this.copyUMOs}
          umoList={umoGallery.get('umoList')}
          isSortMode={mainUI.get('gallerySortMode')}
          pageNumber={umoGallery.get('pageNumber')}
          pageTotal={umoGallery.get('pageTotal')}
          onPageChange={onPageChange}
          toggleCompareView={() =>
            toggleCompareViewDispatch(umoGallery.get('selectedUMOIDs'))
          }
          isMetaAttachView={metaAttach.get('viewType') !== META_ATTACH_VIEW_NONE}
          metatags={session.get('metatags')}
          filterByList={umoGallery.getIn(['searchParams', 'filterByList'])}
          userCollection={
            session.get('userCollection') || DEFAULT_COLLECTION_ID
          }
          changeDataLanguage={changeDataLanguageDispatch}
          selectedLanguage={session.get('dataLanguage')}
          languageList={session.get('languageList')}
          umoTotal={umoGallery.get('umoTotal')}
        />
        {mainUI.get('isHighlightsViewShown') ? <HighlightsView /> : null}
        {!searchParams.isEmpty() ? ( // only display headers if a search was done
          <UMOGalleryHeaderInfo
            mainDescription={this.state.mainDescription}
            umoTotal={umoGallery.get('umoTotal')}
            isLoading={umoGallery.get('isRequesting')}
            isSortMode={mainUI.get('gallerySortMode')}
            selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
            isSelectAll={umoGallery.get('isSelectAll')}
          />
        ) : null}
        <MetaAttach
          metaAttachState={metaAttach}
          allMetatags={session.get('metatags')}
          dispatch={dispatch}
          selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
          isSelectAll={umoGallery.get('isSelectAll')}
          umoTotal={umoGallery.get('umoTotal')}
          searchParams={umoGallery.get('searchParams')}
          selectedLanguage={session.get('dataLanguage')}
        />
        <div
          className={classNames('grid-wrapper',
            mainUI.get('metaPanelUmoId') ? ' grid-wrapper--show' : '',
            metaAttach.get('viewType') !== META_ATTACH_VIEW_NONE ? 'umo-gallery__meta-attach--open' : '',
          )}
        >
          {mainUI.get('isMetaPanelShown') && this.renderMetaPanel()}
          {(!umoGallery.get('umoTotal') || umoGallery.get('umoTotal') === 0) &&
            !umoGallery.get('isRequesting') ?
            <UMONoItemFound
              isSearchEmpty={searchParams.isEmpty()}
              welcomeMessage={appConfig.welcomeMessage}
            /> :
          <UMOGridLayout
            isOptionalIconsOverflow={isOptionalIconsOverflow}
            customMetatag={appConfig.customClassMetatag}
            umoRatings={appConfig.umoRatings}
            umoList={umoGallery.get('umoList')}
            searchParams={umoGallery.get('searchParams')}
            selectedUMOIDs={umoGallery.get('selectedUMOIDs')}
            isLoading={umoGallery.get('isRequesting')}
            isSelectAll={umoGallery.get('isSelectAll')}
            isUMOGalleryWorkspace={this.state.isWorkspace}
            dispatch={dispatch}
            onDetailViewClick={toggleUMODetailViewDispatch}
            isNotJustified={
              mainUI.get('umoGalleryViewType') === viewTypes.GRID_NOJ
            }
            dragSelectedUMOS={this.state.dragSelectedUMOS}
            selectedWorkspaceData={
              this.state.isWorkspace
                ? { id: this.state.workspaceID, label: this.state.mainTitle }
                : {
                    id: workspacePreview.get('selectedID'),
                    ...workspacePreview.get('selectedData').toJS(),
                  }
            }
            highlightSetID={
              umoGallery.get('galleryType') ===
              SearchParams.searchTypes.HIGHLIGHT
                ? umoGallery.get('searchParams').tagList[0].value
                : null
            }
            workspaceCardsViewTimes={this.state.cardViewTimes}
            viewType={mainUI.get('umoGalleryViewType')}
            isSortMode={mainUI.get('gallerySortMode')}
            galleryType={umoGallery.get('galleryType')}
            toggleFullImageView={this.props.toggleFullImageViewDispatch}
            retrieveUMOs={this.props.retrieveUMOs}
            selectedMetaPanelId={mainUI.get('metaPanelUmoId')}
            isMetaAttachView={metaAttach.get('viewType') !== META_ATTACH_VIEW_NONE}
          />}
        </div>
        <div className="umo-gallery__copy-screen_overlay">
          <h2 className="umo-gallery__copy-screen_overlay__message">
            {intl.formatMessage({
              id: this.state.isWorkspace ?
              'searchResults.copy-screen.overlayMessageWorkspace' :
              'searchResults.copy-screen.overlayMessageCategory',
            })}
          </h2>
          <h3 className="umo-gallery__copy-screen_overlay__cancel">
            {intl.formatMessage({
              id: 'searchResults.copy-screen.overlayMessageCancel',
            })}
          </h3>
        </div>
      </div>
    );
  }
}

UMOGallery.propTypes = {
  umoGallery: PropTypes.instanceOf(Map),
  session: PropTypes.instanceOf(Map),
  mainUI: PropTypes.instanceOf(Map),
  workspacePreview: PropTypes.instanceOf(Map),
  metaAttach: PropTypes.instanceOf(Map),
  onPageChange: PropTypes.func,
  toggleUMODetailViewDispatch: PropTypes.func,
  dispatch: PropTypes.func,
  toggleCompareViewDispatch: PropTypes.func,
  toggleFullImageViewDispatch: PropTypes.func,
  retrieveUMOs: PropTypes.func,
  changeDataLanguageDispatch: PropTypes.func,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UMOGallery)
);
